<script setup lang="ts">
defineProps<{
  currentStep: number
  steps: string[]
}>()
</script>

<template>
  <div class="flex flex-wrap items-center justify-center pb-6 gap-2">
    <template v-for="(step, index) in steps" :key="index">
      <div class="flex items-center gap-2">
        <div
          class="flex h-7 w-7 items-center justify-center rounded-full border-2 text-xs font-bold transition-colors"
          :class="{
            'border-[#2d5396] bg-[#2d5396] text-white': currentStep > index + 1,
            'border-[#2d5396] bg-white text-[#2d5396]': currentStep === index + 1,
            'border-[#A3B7DD] bg-white text-[#A3B7DD]': currentStep < index + 1,
          }"
        >
          <span v-if="currentStep > index + 1">✓</span>
          <span v-else>{{ index + 1 }}</span>
        </div>

        <span
          class="whitespace-nowrap text-sm"
          :class="currentStep >= index + 1 ? 'font-semibold text-[#2d5396]' : 'text-[#A3B7DD]'"
        >
          {{ step }}
        </span>
      </div>

      <div
        v-if="index < steps.length - 1"
        class="h-px w-6 bg-[#A3B7DD]"
        :class="{ 'bg-[#2d5396]': currentStep > index + 1 }"
      />
    </template>
  </div>
</template>
